<template>
    <div class="col-md-12" data-aos="fade-up" data-aos-delay="10">
<!--          <h2>Search!</h2> -->
<!--          <p class="mb-7">Unleash the power of targeted learning on 'TheSoundOf.NET' with our 'Search' function - your gateway to exploring a curated collection of .NET podcasts tailored to your specific interests.</p>-->
          <div  class="site-block-subscribe">
            <div class="input-group mb-5">
              <input
                type="text"
                @keyup.enter="search"
                v-model="searchText"
                class="form-control border-secondary text-white bg-transparent text-center"
                placeholder="What are you searching for ..."
                aria-describedby="button-addon2"
              >
              <div class="input-group-append">
                <button type="submit"  @click="search"  class="btn btn-dark" id="button-addon2">search</button>
              </div>
            </div>
          </div>
        </div>
</template>

<script>
export default {
  name: "SearchBar",
  data(){return {
    searchText:'',
    style:"background-image: url(/images/hero_bg_1.jpg) !important;"
  }},
  methods:{
    search(){
      console.log("searching: ", this.searchText)
      const url = this.searchText ? `/page/1?search=${this.searchText}` : `/`;
      console.log("SearchBar navigate to:", url)
      this.$router.push(url)
      // this.$router.push({name:'home-paged', params:{p:1}, query:{search:this.searchText}})
    }
  }
};
</script>

<style scoped>
.site-block-subscribe .form-control {
  height: 40px!important;
}
</style>